import { Checkbox, Grid, IconButton, Stack, Typography } from "@mui/material";
import React, { useEffect, useRef, useState } from "react";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import AddIcon from "@mui/icons-material/Add";
import SaveIcon from "@mui/icons-material/Save";
import { DataGrid } from "@mui/x-data-grid";
import { useDispatch, useSelector } from "react-redux";
import CancelIcon from "@mui/icons-material/Cancel";
import DialogBoxComp from "../../../components/common/DialogBox/DialogBoxComp";
import ScreenCard from "../../../components/common/ScreenCard/ScreenCard";
import TableComp from "../../../components/common/TableComp/TableComp";
import InputWithBtnLayoutComp from "../../../components/InputWithBtnLayout/InputWithBtnLayoutComp";
import InputComp from "../../../components/common/InputComp/Input";
import TabComp from "../../../components/TabsComp/TabComp";
import Btn from "../../../components/common/ButtonComp/Btn";
import { asyncStatus } from "../../../utils/asyncStatus";
import { primaryColor } from "../../../utils/themeColors";
import {
  addOMPaymentTypeAsync,
  deleteOMPaymentTypeAsync,
  editOMPaymentTypeAsync,
  getOMPaymentTypeAsync,
} from "../../../store/services/orderManagementService";
const PaymentType = () => {
  const dispatch = useDispatch();
  const {
    getOMPaymentTypeStatus,
    getOMPaymentTypeError,
    getOMPaymentTypeData,
    addOMPaymentTypeStatus,
    addOMPaymentTypeData,
    addOMPaymentTypeError,

    editOMPaymentTypeStatus,
    editOMPaymentTypeError,
    editOMPaymentTypeData,

    deleteOMPaymentTypeData,
    deleteOMPaymentTypeStatus,
    deleteOMPaymentTypeError,
  } = useSelector((state) => state.om);

  useEffect(() => {
    dispatch(getOMPaymentTypeAsync());
  }, []);

  // console.log("getProductStyleData", getProductStyleData);
  const formattedData = getOMPaymentTypeData?.length
    ? getOMPaymentTypeData.map((style, index) => ({
        id: index + 1, // Assuming the index is a unique identifier for each row
        ...style,
      }))
    : [];
  const [selectedPaymentType, setSelectedPaymentType] = useState();
  const [addPaymentTypeMode, setAddPaymentTypeMode] = useState(false);
  const [addPaymentTypeData, setAddPaymentTypeData] = useState();
  const [saveDisabled, setSaveDisabled] = useState(true);
  const [editData, setEditData] = useState();
  const [editMode, setEditMode] = useState(false);
  // console.log("selectedPaymentType", selectedPaymentType);
  // console.log("editData", editData);
  useEffect(() => {
    if (addOMPaymentTypeStatus === asyncStatus.SUCCEEDED) {
      setAddPaymentTypeMode(false);
      setSaveDisabled(true);
      setAddPaymentTypeData();
    }
  }, [, addOMPaymentTypeStatus]);

  const [open, setOpen] = useState(false);
  const agree = () => {
    dispatch(deleteOMPaymentTypeAsync(selectedPaymentType?.payment_type_id));
  };
  const handleClose = () => {
    setOpen(false);
  };
  useEffect(() => {
    if (deleteOMPaymentTypeStatus === asyncStatus.SUCCEEDED || deleteOMPaymentTypeStatus === asyncStatus.ERROR ) {
      setOpen(false);
      setSelectedPaymentType();
    }
  }, [, deleteOMPaymentTypeStatus]);
  useEffect(() => {
    if (editOMPaymentTypeStatus === asyncStatus.SUCCEEDED) {
      setSelectedPaymentType();
      setEditMode(false);
      setEditData()
    }
  }, [, editOMPaymentTypeStatus]);

  //   const [tableHeight, setTableHeight] = useState("");
  //   let elem = document.getElementById("containerHeight");
  //   useEffect(() => {
  //     console.log("elem?.offsetHeight",elem?.clientHeight);
  //     setTableHeight(elem?.offsetHeight);
  //   }, [ elem?.offsetHeight]);
  // console.log(containerHeight)
  return (
    <Stack padding={2}>
      <DialogBoxComp
        open={open}
        handleClose={handleClose}
        agree={agree}
        innerContent={"Are you sure you want to delete this payment type?"}
        heading={"Delete request"}
      />
      <ScreenCard
        title="Payment Type"
        customHeader={
          <Stack
            sx={{
              padding: 0.5,
              px: 4,
              backgroundColor: primaryColor,
              flexDirection: "row",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <Typography sx={{ color: "white", fontWeight: "bold" }}>
              Payment Type
            </Typography>
            <Stack flexDirection={"row"} gap={1}>
              <IconButton
                onClick={() => {
                  setEditMode(false);
                  setAddPaymentTypeMode((prev) => !prev);
                  setSaveDisabled(false);
                }}
              >
                {!addPaymentTypeMode ? (
                  <AddIcon sx={{ color: "white" }} />
                ) : (
                  <CancelIcon sx={{ color: "white" }} />
                )}
              </IconButton>
              <IconButton
                disabled={addPaymentTypeMode}
                sx={{ color: "white", ":disabled": { color: "gray" } }}
                onClick={() => {
                  setAddPaymentTypeMode(false);
                  setEditMode((prev) => !prev);
                  setSaveDisabled(false);
                }}
              >
                {!editMode ? (
                  <EditIcon />
                ) : (
                  <CancelIcon sx={{ color: "white" }} />
                )}
              </IconButton>
              <IconButton
                disabled={addPaymentTypeMode || !selectedPaymentType}
                sx={{ color: "white", ":disabled": { color: "gray" } }}
                onClick={() => setOpen(true)}
              >
                <DeleteIcon />
              </IconButton>
              <IconButton
                disabled={
                  addOMPaymentTypeStatus === asyncStatus.LOADING ||
                  editOMPaymentTypeStatus === asyncStatus.LOADING ||
                  saveDisabled
                }
                sx={{ color: "white", ":disabled": { color: "gray" } }}
                onClick={() => {
                  if (addPaymentTypeData) {
                    dispatch(addOMPaymentTypeAsync(addPaymentTypeData));
                  } else if (editMode) {
                    let a;
                    a = { ...selectedPaymentType, ...editData };
                    delete a.id;
                    dispatch(editOMPaymentTypeAsync(a));
                  }
                }}
              >
                <SaveIcon />
              </IconButton>
            </Stack>
          </Stack>
        }
      >
        <Grid container>
          <Grid item xl={3} lg={3} md={3} sm={12} xs={12}>
            <Stack height={500} width={"100%"}>
              <TableComp
                columns={[
                  { field: "payment_type_id", headerName: "ID", flex: true },
                  { field: "payment_type_name", headerName: "Payment Type", flex: true },
                ]}
                onRowClick={(e) => {
                  setSelectedPaymentType(e?.row);
                }}
                rows={formattedData}
                loading={
                  getOMPaymentTypeStatus === asyncStatus.IDLE ||
                  getOMPaymentTypeStatus === asyncStatus.LOADING
                }
              />
            </Stack>
          </Grid>
          <Grid item xl={9} lg={9} md={9} sm={12} xs={12} padding={2}>
            {addPaymentTypeMode ? (
              <InputWithBtnLayoutComp
              error={addOMPaymentTypeError}
                inputArray={[
                  {
                    label: "Payment Type:",
                    comp: (
                      <InputComp
                        style={{ borderRadius: 5, fontSize: 12, padding: 4 }}
                        placeholder=""
                        onChange={(e) =>
                          setAddPaymentTypeData({
                            ...addPaymentTypeData,
                            payment_type_name: e.target.value,
                          })
                        }
                      />
                    ),
                  },
                  {
                    label: "Active:",
                    comp: (
                      <Checkbox
                        defaultChecked
                        defaultValue={true}
                        onChange={(e) =>
                          setAddPaymentTypeData({
                            ...addPaymentTypeData,
                            is_active: e.target.checked,
                          })
                        }
                      />
                    ),
                  },
                ]}
                secondaryComp={<></>}
              />
            ) : selectedPaymentType ? (
              <InputWithBtnLayoutComp
              error={editOMPaymentTypeError}
                inputArray={[
                  {
                    label: "ID:",
                    comp: (
                      <Typography sx={{ fontSize: 14 }}>
                        {selectedPaymentType?.payment_type_id}
                      </Typography>
                    ),
                  },
                  {
                    label: "Payment Type:",
                    comp: (
                      <InputComp
                        key={selectedPaymentType?.payment_type_id} // Add key prop to force remount
                        disabled={!editMode}
                        onChange={(e) =>
                          setEditData({
                            ...editData,
                            payment_type_name: e.target.value,
                          })
                        }
                        style={{ borderRadius: 5, fontSize: 12, padding: 4 }}
                        placeholder=""
                        defaultValue={selectedPaymentType?.payment_type_name}
                      />
                    ),
                  },
                  {
                    label: "Active:",

                    comp: (
                      <Checkbox
                        onChange={(e) =>
                          setEditData({
                            ...editData,
                            is_active: e.target.checked,
                          })
                        }
                        value={selectedPaymentType?.is_active|| editData?.is_active}
                        disabled={!editMode}
                        // defaultValue={selectedPaymentType?.is_active || editData?.is_active}
                        defaultChecked={selectedPaymentType?.is_active || editData?.is_active}
                        // checked={selectedPaymentType?.is_active}
                      />
                    ),
                  },
                ]}
                secondaryComp={
                  <Btn
                    style={{ fontSize: 10, fontWeight: "bold" }}
                    disabled={editMode}
                  >
                    Assign Companies
                  </Btn>
                }
              />
            ) : (<Stack>
              <Typography>Select any payment type</Typography>
              <Typography color={"red"} fontSize={12}>{getOMPaymentTypeError}</Typography>
            </Stack>
            )}
            <Stack my={2}>
              <TabComp
                tabs={[
                  //   {
                  //     name: "Companies",
                  //     content: (
                  //       <Stack height={400} width={"100%"}>
                  //         <TableComp
                  //           columns={[
                  //             {
                  //               field: "companyId",
                  //               headerName: "Company ID",
                  //               flex: true,
                  //             },
                  //             {
                  //               field: "companyName",
                  //               headerName: "Company Name",
                  //               flex: true,
                  //             },
                  //             {
                  //               field: "action",
                  //               headerName: "Action",
                  //               flex: true,
                  //             },
                  //           ]}
                  //           //   onRowClick={(e) => {
                  //           //     setSelectedPaymentType(e?.row);
                  //           //   }}
                  //           rows={[]}
                  //           //   loading={
                  //           //     getProductStyleStatus === asyncStatus.IDLE ||
                  //           //     getProductStyleStatus === asyncStatus.LOADING
                  //           //   }
                  //         />
                  //       </Stack>
                  //     ),
                  //   },
                  {
                    name: "Log Info",
                    content: (
                      <Stack height={400} width={"100%"}>
                        <TableComp
                          columns={[
                            {
                              field: "logId",
                              headerName: "Log ID",
                              flex: true,
                            },
                            {
                              field: "recordId",
                              headerName: "Record_id",
                              flex: true,
                            },
                            {
                              field: "columnName",
                              headerName: "Column Name",
                              flex: true,
                            },
                            {
                              field: "columnValue",
                              headerName: "Column Value",
                              flex: true,
                            },
                            {
                              field: "actionName",
                              headerName: "Action Name",
                              flex: true,
                            },
                            {
                              field: "actionDate",
                              headerName: "Action Date",
                              flex: true,
                            },
                            {
                              field: "userId",
                              headerName: " User ID",
                              flex: true,
                            },
                          ]}
                          //   onRowClick={(e) => {
                          //     setSelectedPaymentType(e?.row);
                          //   }}
                          rows={[]}
                          //   loading={
                          //     getProductStyleStatus === asyncStatus.IDLE ||
                          //     getProductStyleStatus === asyncStatus.LOADING
                          //   }
                        />
                      </Stack>
                    ),
                  },
                ]}
              />
            </Stack>
          </Grid>
        </Grid>

        {/* <div style={{ height: 400, width: '100%' }}>
      <DataGrid
      sty
        rows={rows}
        columns={columns}
        initialState={{
          pagination: {
            paginationModel: { page: 0, pageSize: 5 },
          },
        }}
        pageSizeOptions={[5, 10]}
        // checkboxSelection
      />
    </div> */}
      </ScreenCard>
    </Stack>
  );
};

export default PaymentType;
